import React, { useEffect, useState } from "react";
import "../styles/About.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HomeWhyChoose from "../pages/home/HomeWhyChoose";
import AboutCTA from "../pages/AboutCTA";

import { FiShield, FiCalendar, FiBriefcase, FiSettings, FiArrowDown } from "react-icons/fi";

const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

const About = () => {
    const [siteSettings, setSiteSettings] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchSiteSettings = async () => {
            try {
                const res = await fetch(`${API_BASE_URL}/api/site-settings`);
                const data = await res.json();
                setSiteSettings(data);
            } catch (error) {
                console.error("Failed to load site settings:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchSiteSettings();
    }, []);

    const scrollToPLS = () => {
        const section = document.getElementById("pls-section");
        section?.scrollIntoView({ behavior: "smooth" });
    };

    if (loading) {
        return (
            <>
                <Header />
                <div className="about-page">
                    <p style={{ textAlign: "center", padding: "100px 0" }}>
                        Loading about information...
                    </p>
                </div>
                <Footer />
            </>
        );
    }

    return (
        <>
            <Header />

            {/* ================= HERO ================= */}
            <section className="about-hero">
                <div className="about-hero-overlay">
                    <h1>Connecting you with the right legal <span>expertise</span></h1>
                    <p>
                        We bridge the gap between people and justice by providing a
                        transparent, vetted, and efficient digital marketplace for legal
                        services.
                    </p>

                    {/* Read More button */}
                    <button className="hero-read-btn" onClick={scrollToPLS}>
                        Read More
                    </button>

                </div>
            </section>

            <div className="about-page">

                {/* ================= Personalized Legal Solutions ================= */}
                <section className="pls-section" id="pls-section">
                    <div className="pls-grid">

                        <div className="pls-left">
                            <h2>
                                Personalized <span>Legal</span> Solutions
                            </h2>

                            <p>
                                {siteSettings?.aboutDescription ||
                                    "In an era of automated services, we prioritize a bespoke legal experience."}
                            </p>

                            <div className="pls-mv">
                                <div className="pls-box">
                                    <h4>Our Mission</h4>
                                    <p>
                                        {siteSettings?.mission ||
                                            "Democratizing elite legal expertise through curated matches."}
                                    </p>
                                </div>

                                <div className="pls-box">
                                    <h4>Our Vision</h4>
                                    <p>
                                        {siteSettings?.vision ||
                                            "Setting a global benchmark for legal accessibility and integrity."}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="pls-right">
                            <img src="/Home/a1.png" alt="Legal experts" />
                        </div>

                        {/* Contact button under Mission & Vision */}
                        <div className="pls-contact-wrap">
                            <button
                                className="pls-contact-btn"
                                onClick={() => (window.location.href = "/contact")}
                            >
                                Contact Us
                            </button>
                        </div>

                    </div>
                </section>

                {/* ================= Our Story ================= */}
                <section className="about-story">
                    <div className="about-story-grid">

                        <div className="about-story-image">
                            <img src="/Home/a2.png" alt="Our team" />
                        </div>

                        <div className="about-story-text">
                            <h2>Our <span>Story</span></h2>

                            <p>
                                Finding the right legal counsel is often a daunting and opaque
                                process. Most people only need a solicitor during the most
                                stressful times of their lives.
                            </p>

                            <p>
                                We founded this platform to replace uncertainty with clarity.
                                We’ve created a space where excellence meets accessibility.
                                Today, we help thousands of individuals and businesses find the
                                perfect legal match within minutes.
                            </p>
                        </div>

                    </div>
                </section>


                {/* ================= What We Offer ================= */}
                {/* ================= What We Offer ================= */}
                <section className="offer-section-new">

                    <div className="offer-container">

                        {/* LEFT CONTENT */}
                        <div className="offer-left">
                            <h2 className="offer-title-new">
                                What <span>We Offer</span>
                            </h2>

                            <p className="offer-subtitle-new">
                                We provide powerful tools to simplify and secure your legal journey.
                            </p>

                            <div className="offer-list">

                                <div className="offer-item">
                                    <FiCalendar className="offer-icon" />
                                    <div>
                                        <h4>Easy Appointment Booking</h4>
                                        <p>Quick and simple online booking with smart time validation.</p>
                                    </div>
                                </div>

                                <div className="offer-item">
                                    <FiBriefcase className="offer-icon" />
                                    <div>
                                        <h4>Smart Case Management</h4>
                                        <p>Track cases, hearings, and updates in a single dashboard.</p>
                                    </div>
                                </div>

                                <div className="offer-item">
                                    <FiSettings className="offer-icon" />
                                    <div>
                                        <h4>Powerful Solicitor Panel</h4>
                                        <p>Manage appointments, cases, hearings, agreements and content dynamically.</p>
                                    </div>
                                </div>

                                <div className="offer-item">
                                    <FiShield className="offer-icon" />
                                    <div>
                                        <h4>Secure & Reliable</h4>
                                        <p>Strong security practices to protect confidential data.</p>
                                    </div>
                                </div>

                            </div>
                        </div>

                        {/* RIGHT IMAGE */}
                        <div className="offer-right">
                            <img src="/Home/wwo.png" alt="lawyers" />
                        </div>

                    </div>
                </section>

                <div className="about-why-wrapper">
                    <HomeWhyChoose />
                </div>

                <div className="about-cta-wrapper">
                    <AboutCTA />
                </div>
            </div>

            <Footer />
        </>
    );
};

export default About;
